import React, { useEffect, useRef, useState } from 'react';
import { Protected } from '@components/layout/Protected';
import { Alert, Backdrop, CircularProgress, Container, Divider, Grid, IconButton, Menu, MenuItem, Snackbar } from "@mui/material";
import { TableDataV2 } from '@/components/common/Tablev2';
import { costCentersRepository } from '@/service/repositories/CostCenters.repository';
import { Loading } from '@/components/common/Loading';
import { Props } from './InventoryWorkers.type';
import ___PHRASE from '@/service/translate/translateService';


export const InventoryWorkersView: React.FC<Props> = (props:any): JSX.Element => {

   const [loading, setLoading] = useState<boolean>(false);
   const [costCenters, setCostCenters] = useState([]);
   const [showCostCenterModal, setShowCostCenterModal] = useState<boolean>(false);
   const [showCostCenterDeleteModal, setShowCostCenterDeleteModal] = useState<boolean>(false);
   const [actionSelected, setActionSelected] = useState<String>('');
   const [costCenterSelected, setCostCenterSelected] = useState<String>('');

   useEffect(() => {
      getCenterCostos()
   },[]);

   const getCenterCostos = async () => {
      setLoading(true);
      const response = await costCentersRepository.getCostCenters();
      if (response.data) {
         setCostCenters(response.data || [])
      } else {
         console.log('error')
      }
      setLoading(false);
   }

   function RecuperarData(value){
      console.log(value)
   }

   const searchData = async (value) => {
      const response = await costCentersRepository.getCostCenters(value);
      if (response.data) {
         setCostCenters(response.data || [])
      } else {
         console.log('error')
      }
   }

  return (
      <Protected>
         {loading && <Loading/>}
         <Container>
            <TableDataV2
               title={___PHRASE("centrosdecostos")}
               data={costCenters}
               header={[
                  { name: 'name', label: ___PHRASE("nombre"), filter: false, Chip: true },
                  { name: 'description', label: ___PHRASE("descripcion"), filter: false, Chip: false },
               ]}
               actionSelect={setActionSelected}
               setModalSave={setShowCostCenterModal}
               setModalDelete={setShowCostCenterDeleteModal}
               status_action
               textSearch={'Buscar Centro de costo'}
               searchData={searchData}
               // checkbox
               RecuperarData={RecuperarData}
            />
         </Container>
      
      </Protected>
   )
};